<section class="entity-page" *ngIf="config as currentConfig">
  <header class="page-header entity-header">
    <div>
      <h1>{{ currentConfig.title }}</h1>
      <p>{{ currentConfig.description }}</p>
    </div>

    <div class="header-actions">
      <button type="button" routerLink="/dashboard" class="nav-button">
        Back to dashboard
      </button>
      <button type="button" class="primary-button" (click)="openCreateModal()">
        Add {{ currentConfig.singular }}
      </button>
    </div>
  </header>

  <section class="table-shell">
    <table>
      <thead>
        <tr>
          <th>ID</th>
          <th *ngFor="let field of fields">{{ field.label }}</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of records; trackBy: getTrackByRecord">
          <td>{{ record.id }}</td>
          <td *ngFor="let field of fields">{{ getCellValue(record, field.key) }}</td>
          <td>
            <div class="table-actions">
              <button type="button" class="ghost-button" (click)="openEditModal(record)">Edit</button>
              <button type="button" class="danger-button" (click)="deleteRecord(record)">Delete</button>
            </div>
          </td>
        </tr>
        <tr *ngIf="records.length === 0">
          <td [attr.colspan]="fields.length + 2" class="empty-state">No records available.</td>
        </tr>
      </tbody>
    </table>
  </section>

  <div class="modal-backdrop" *ngIf="isModalOpen">
    <div class="modal-panel" role="dialog" aria-modal="true">
      <div class="modal-header">
        <div>
          <span class="eyebrow">{{ isEditMode ? 'Update record' : 'Create record' }}</span>
          <h2>{{ isEditMode ? 'Edit' : 'Add' }} {{ currentConfig.singular }}</h2>
        </div>
        <button type="button" class="icon-button" (click)="closeModal()">Close</button>
      </div>

      <form class="modal-form" (ngSubmit)="saveRecord()">
        <label *ngFor="let field of fields">
          <span>{{ field.label }}</span>

          <ng-container *ngIf="field.type === 'select'; else textField">
            <div
              *ngIf="hasDetailedOptions(field); else basicSelect"
              class="detail-dropdown"
            >
              <button
                type="button"
                class="detail-dropdown-trigger"
                [class.detail-dropdown-trigger-open]="isDetailedDropdownOpen(field.key)"
                (click)="toggleDetailedDropdown(field.key)"
                [attr.aria-expanded]="isDetailedDropdownOpen(field.key)"
                aria-haspopup="listbox"
              >
                <span class="detail-dropdown-value" *ngIf="getSelectedOption(field) as selectedOption">
                  <span class="option-title">{{ selectedOption.label }}</span>
                  <small class="option-description" *ngIf="selectedOption.description">
                    {{ selectedOption.description }}
                  </small>
                </span>
                <small class="detail-dropdown-placeholder" *ngIf="!getSelectedOption(field)">
                  {{ field.placeholder }}
                </small>
                <span class="detail-dropdown-arrow">▾</span>
              </button>

              <div
                class="detail-dropdown-menu"
                *ngIf="isDetailedDropdownOpen(field.key)"
                role="listbox"
                [attr.aria-label]="field.label"
              >
                <button
                  type="button"
                  class="option-card"
                  *ngFor="let option of field.options ?? []"
                  [class.option-card-selected]="isSelectedOption(field, option)"
                  [attr.aria-selected]="isSelectedOption(field, option)"
                  (click)="selectDetailedOption(field, option)"
                >
                  <span class="option-title">{{ option.label }}</span>
                  <small class="option-description" *ngIf="option.description">
                    {{ option.description }}
                  </small>
                </button>
              </div>
            </div>

            <ng-template #basicSelect>
              <select
                [ngModel]="draft[field.key]"
                [name]="field.key"
                (ngModelChange)="updateDraft(field.key, $event)"
              >
                <option *ngFor="let option of field.options ?? []" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </ng-template>
          </ng-container>

          <ng-template #textField>
            <input
              [type]="field.type"
              [name]="field.key"
              [placeholder]="field.placeholder"
              [ngModel]="draft[field.key]"
              (ngModelChange)="updateDraft(field.key, $event)"
            />
          </ng-template>
        </label>

        <p class="error-message" *ngIf="formError">{{ formError }}</p>

        <div class="modal-actions">
          <button type="button" class="secondary-button" (click)="closeModal()">Cancel</button>
          <button type="submit" class="primary-button">{{ isEditMode ? 'Update' : 'Save' }}</button>
        </div>
      </form>
    </div>
  </div>
</section>